import React, { useState, useEffect } from "react";
import axios from "axios";

const Email = () => {
  const currentUser = localStorage.getItem("email");
  const [inboxPage, setInboxPage] = useState(1);
  const [sentPage, setSentPage] = useState(1);
  const emailsPerPage = 5;

  const [view, setView] = useState("inbox");
  const [emails, setEmails] = useState({
    inbox: [],
    sent: [],
  });
  const [error, setError] = useState("");
  const [openMenuId, setOpenMenuId] = useState(null);

  const [form, setForm] = useState({
    to: "",
    subject: "",
    message: "",
    file: null,   // ✅ ADD THIS
  });

  // ✅ NEW: Meeting State
  const [meetingForm, setMeetingForm] = useState({
    title: "",
    date: "",
    time: "",
    participants: "",
  });

  // ✅ Fetch Emails
  const fetchEmails = async () => {
    try {
      const adminRes = await axios.get(
        `https://rhrmapi.up2dateinc.com/api/email/admin/all?email=${currentUser}`
      );

      setEmails({
        inbox: adminRes.data,
        sent: adminRes.data,
      });
    } catch (err) {
      try {
        const inboxRes = await axios.get(
          `https://rhrmapi.up2dateinc.com/api/email/inbox/${currentUser}`
        );

        const sentRes = await axios.get(
          `https://rhrmapi.up2dateinc.com/api/email/sent/${currentUser}`
        );

        setEmails({
          inbox: inboxRes.data,
          sent: sentRes.data,
        });
      } catch (error) {
        console.error(error);
      }
    }
  };

  useEffect(() => {
    if (currentUser) fetchEmails();
  }, [currentUser]);

  // ✅ Delete Email
  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://rhrmapi.up2dateinc.com/api/email/${id}`);
      fetchEmails();
    } catch (err) {
      console.error(err);
    }
  };

  // ✅ Check Email Exists
  const checkEmailExists = async (email) => {
    try {
      const res = await axios.get(
        `https://rhrmapi.up2dateinc.com/api/email/check-email?email=${email}`
      );
      return res.data.exists;
    } catch {
      return false;
    }
  };

  // ✉️ Send Email
  const handleSend = async () => {
  setError("");

  if (!form.to || !form.subject || !form.message) {
    setError("All fields required");
    return;
  }

  const emailsList = form.to
    .split(",")
    .map((e) => e.trim());

  for (let email of emailsList) {
    const isValid = await checkEmailExists(email);
    if (!isValid) {
      setError(`❌ Invalid Email: ${email}`);
      return;
    }
  }

  

  try {
    const data = new FormData();

    data.append("from", currentUser);
    data.append("to", JSON.stringify(emailsList));
    data.append("subject", form.subject);
    data.append("message", form.message);

    if (form.file) {
      data.append("file", form.file);
    }

    await axios.post(
      "https://rhrmapi.up2dateinc.com/api/email/send",
      data
    );

    // ✅ reset form
    setForm({
      to: "",
      subject: "",
      message: "",
      file: null,
    });

    setView("sent");
    fetchEmails();

  } catch (err) {
    setError("Error sending email");
  }
};

  // 📅 CREATE MEETING
  const handleCreateMeeting = async () => {
    if (
      !meetingForm.title ||
      !meetingForm.date ||
      !meetingForm.time ||
      !meetingForm.participants
    ) {
      alert("All fields required");
      return;
    }

    try {
      const participantsArray = meetingForm.participants
        .split(",")
        .map((e) => e.trim());

      await axios.post("https://rhrmapi.up2dateinc.com/api/meeting/create", {
        title: meetingForm.title,
        date: meetingForm.date,
        time: meetingForm.time,
        participants: participantsArray,
        createdBy: currentUser,
      });

      alert("✅ Meeting Created");

      setMeetingForm({
        title: "",
        date: "",
        time: "",
        participants: "",
      });

      setView("inbox"); // go back

    } catch (err) {
      alert(err.response?.data?.error || "Error creating meeting");
    }
  };

  // 🎨 Styles
  const sidebarBtn = {
    display: "block",
    width: "100%",
    padding: "10px",
    marginBottom: "10px",
    border: "none",
    background: "#fff",
    cursor: "pointer",
    borderRadius: "6px",
  };

  const card = {
    display: "flex",
    justifyContent: "space-between",
    padding: "15px",
    marginBottom: "10px",
    border: "1px solid #ddd",
    borderRadius: "10px",
    background: "#fff",
  };

  const deleteBtn = {
    background: "red",
    color: "#fff",
    border: "none",
    padding: "6px 10px",
    cursor: "pointer",
    borderRadius: "5px",
  };

  const input = {
    width: "100%",
    padding: "10px",
    marginBottom: "10px",
    border: "1px solid #ccc",
    borderRadius: "5px",
  };

  const sendBtn = {
    background: "#007bff",
    color: "#fff",
    padding: "10px 20px",
    border: "none",
    cursor: "pointer",
    borderRadius: "5px",
  };

const paginate = (data, page) => {
  const startIndex = (page - 1) * emailsPerPage;
  return data.slice(startIndex, startIndex + emailsPerPage);
};

const totalPages = (data) =>
  Math.ceil(data.length / emailsPerPage);

  return (
    <div style={{ display: "flex", height: "100vh", fontFamily: "Arial" }}>
      
      {/* Sidebar */}
      <div style={{
        width: "250px",
        background: "#0b1f3a",
        padding: "20px"
      }}>
        <h3 style={{ color: "#fff" }}>📧 Mail</h3>

        <button style={sidebarBtn} onClick={() => setView("compose")}>
          ✏️ Compose
        </button>

        <button style={sidebarBtn} onClick={() => setView("inbox")}>
          📥 Inbox
        </button>

        <button style={sidebarBtn} onClick={() => setView("sent")}>
          📤 Sent
        </button>

        {/* ✅ NEW BUTTON */}
        <button style={sidebarBtn} onClick={() => setView("meeting")}>
          📅 Schedule Meeting
        </button>
      </div>

      {/* Main */}
      <div style={{ flex: 1, padding: "20px" }}>

        {error && <p style={{ color: "red" }}>{error}</p>}

        {/* Inbox */}
        {view === "inbox" && (
          <>
            <h2>📥 Inbox</h2>

            {emails.inbox.length === 0 && <p>No emails</p>}

            {paginate(emails.inbox, inboxPage).map((mail) => (
              <div key={mail.id} style={card}>
                <div>
                  <b>From:</b> {mail.from} <br />
                  <b>Subject:</b> {mail.subject}
                  <p>{mail.message}</p>
                  {mail.file && (
                    <p>
                      📎{" "}
                      <a
                        href={`https://rhrmapi.up2dateinc.com/uploads/${mail.file}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        View Attachment
                      </a>
                    </p>
                  )}
                </div>

                

                <div style={{ position: "relative" }}>
  <button
    onClick={() =>
      setOpenMenuId(openMenuId === mail.id ? null : mail.id)
    }
    style={{
      background: "transparent",
      border: "none",
      fontSize: "20px",
      cursor: "pointer",
    }}
  >
    ⋮
  </button>

  {openMenuId === mail.id && (
    <div
      style={{
        position: "absolute",
        top: "25px",
        right: "0",
        background: "#fff",
        border: "1px solid #ccc",
        borderRadius: "5px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
        zIndex: 1,
      }}
    >
      <button
        onClick={() => handleDelete(mail.id)}
        style={{
          padding: "8px 12px",
          border: "none",
          background: "none",
          cursor: "pointer",
          width: "100%",
          textAlign: "left",
        }}
      >
        🗑 Delete
      </button>
    </div>
  )}
</div>
              </div>
            ))}
            

{/* ✅ PAGINATION HERE (BOTTOM OF BOX) */}
<div style={{ marginTop: "20px", textAlign: "center" }}>
  {Array.from(
    { length: totalPages(emails.inbox) },
    (_, i) => (
      <button
        key={i}
        onClick={() => setInboxPage(i + 1)}
        style={{
          margin: "5px",
          padding: "8px 12px",
          background: inboxPage === i + 1 ? "#007bff" : "#ddd",
          color: inboxPage === i + 1 ? "#fff" : "#000",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        {i + 1}
      </button>
    )
  )}
</div>
          </>
        )}

        {/* Sent */}
        {view === "sent" && (
          <>
            <h2>📤 Sent</h2>

            {emails.sent.length === 0 && <p>No emails</p>}

            {paginate(emails.sent, sentPage).map((mail) => (
              <div key={mail.id} style={card}>
                <div>
                  <b>To:</b> {Array.isArray(mail.to) ? mail.to.join(", ") : mail.to} <br />
                  <b>Subject:</b> {mail.subject}
                  <p>{mail.message}</p>
                  {mail.file && (
                    <p>
                      📎{" "}
                      <a
                        href={`https://rhrmapi.up2dateinc.com/uploads/${mail.file}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        View Attachment
                      </a>
                    </p>
                  )}
                </div>

                

                <div style={{ position: "relative" }}>
  <button
    onClick={() =>
      setOpenMenuId(openMenuId === mail.id ? null : mail.id)
    }
    style={{
      background: "transparent",
      border: "none",
      fontSize: "20px",
      cursor: "pointer",
    }}
  >
    ⋮
  </button>

  {openMenuId === mail.id && (
    <div
      style={{
        position: "absolute",
        top: "25px",
        right: "0",
        background: "#fff",
        border: "1px solid #ccc",
        borderRadius: "5px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
        zIndex: 1,
      }}
    >
      <button
        onClick={() => handleDelete(mail.id)}
        style={{
          padding: "8px 12px",
          border: "none",
          background: "none",
          cursor: "pointer",
          width: "100%",
          textAlign: "left",
        }}
      >
        🗑 Delete
      </button>
    </div>
  )}
</div>
              </div>
            ))}
            

{/* ✅ PAGINATION HERE */}
<div style={{ marginTop: "20px", textAlign: "center" }}>
  {Array.from(
    { length: totalPages(emails.sent) },
    (_, i) => (
      <button
        key={i}
        onClick={() => setSentPage(i + 1)}
        style={{
          margin: "5px",
          padding: "8px 12px",
          background: sentPage === i + 1 ? "#007bff" : "#ddd",
          color: sentPage === i + 1 ? "#fff" : "#000",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        {i + 1}
      </button>
    )
  )}
</div>
          </>
        )}

        {/* Compose */}
        {view === "compose" && (
          <>
            <h2>✏️ Compose</h2>

            <input
              placeholder="To"
              value={form.to}
              onChange={(e) =>
                setForm({ ...form, to: e.target.value })
              }
              style={input}
            />

            <input
              placeholder="Subject"
              value={form.subject}
              onChange={(e) =>
                setForm({ ...form, subject: e.target.value })
              }
              style={input}
            />

            <textarea
              placeholder="Message"
              value={form.message}
              onChange={(e) =>
                setForm({ ...form, message: e.target.value })
              }
              style={{ ...input, height: "120px" }}
            />

            <input
              type="file"
              onChange={(e) =>
                setForm({ ...form, file: e.target.files[0] })
              }
              style={input}
            />

            {form.file && <p>📎 {form.file.name}</p>}

            <button style={sendBtn} onClick={handleSend}>
              Send
            </button>
          </>
        )}

        {/* ✅ MEETING UI */}
        {view === "meeting" && (
          <>
            <h2>📅 Schedule Meeting</h2>

            <input
              placeholder="Title"
              value={meetingForm.title}
              onChange={(e) =>
                setMeetingForm({ ...meetingForm, title: e.target.value })
              }
              style={input}
            />

            <input
              type="date"
              value={meetingForm.date}
              onChange={(e) =>
                setMeetingForm({ ...meetingForm, date: e.target.value })
              }
              style={input}
            />

            <input
              type="time"
              value={meetingForm.time}
              onChange={(e) =>
                setMeetingForm({ ...meetingForm, time: e.target.value })
              }
              style={input}
            />

            <input
              placeholder="Participants (comma separated emails)"
              value={meetingForm.participants}
              onChange={(e) =>
                setMeetingForm({
                  ...meetingForm,
                  participants: e.target.value,
                })
              }
              style={input}
            />

            <button style={sendBtn} onClick={handleCreateMeeting}>
              Create Meeting
            </button>
          </>
        )}

      </div>
    </div>
  );
};

export default Email;